import { classNames } from 'libs/react';
import { Button } from 'components/Button';
import { React } from 'libs/react';
import './MediaPickerRemoveButton.scss';
/**
 * @component MediaPickerRemoveButton
 * @since 1.0.0
 */
export function MediaPickerRemoveButton(props) {
    const { size, style, media } = Object.assign({ size: 'medium', style: 'normal' }, props);
    /**
     * @function onPress
     * @since 1.0.0
     * @hidden
     */
    function onPress() {
        if (props.onPress) {
            props.onPress(media);
        }
    }
    const className = classNames('media-picker-remove-button', 'media-picker-remove-button--' + size, 'media-picker-remove-button--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement(Button, { className: "media-picker-remove-button-inner", onPress: onPress, picto: "fal times" })));
}
